import React, { useState, Fragment, useEffect } from 'react';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { FiUpload, FiImage } from 'react-icons/fi';
import ImageGallery from '../../../../propinfo/gallery/index';


import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosUserAPI, AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Site_Settings,
  postAPI_Invite_User,
  gAPI_Group_By_Id,
  postAPI_SSO_Settings,
  getAPI_SSO_By_GroupId,
  API_Ingetration,
} from '../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../components/common/react-notifications';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import currencies from '../../../../../../../data/currencies';
import Select from 'react-select';
import country from '../../../../../../../data/country';
import billingCurrencyList from '../../../../../../../data/billingCurrencyList';
import currencyList from '../../../../../../../data/currencyList';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../../../../helpers/Utils';
import { themeColorStorageKey } from '../../../../../../../constants/defaultValues';
import Validation from '../../../../../../../components/Validation';
// Map SSOStatus enum from backend

export function GroupsForm({
  visible,
  toggle,
  formLabel,
  submit,
  updateGroupsData,
  id,
  serviceProviders,
  userName,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inviteData, setInviteData] = useState('');
  const [selectedCountry, setSelectedCountry] = useState({
    value: 'NZ',
    label: 'New Zealand',
  });
  const [selectedCurrency, setSelectedCurrency] = useState({
    value: 'NZD',
    label: 'NZD',
  });
  const [copied, setCopied] = useState(false);
  const [isSsoEnable, setIsSsoEnable] = useState(false);
  const [saving, setSaving] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [logoPreview, setLogoPreview] = useState('');
  const [logoFile, setLogoFile] = useState(null);

  const providerNumberToString = {
    1: 'AzureApp',
    // add additional mappings if you have them
    // e.g. 3: 'SomeOtherProvider'
  };

  const knownProviders = ['AzureApp'];

  const [ssoData, setSsoData] = useState({
    provider: '',
    clientId: '',
    tenantId: '',
    createdBy: 'Manually',
    groupId: id || '',
    status: '',
    enforcedDomains: [],
    bypassDomains: [],
    integrationId: '',
  });
  const [ssoError, setSsoError] = useState('');
  const [ssoProviderError, setSsoProviderError] = useState('');
  const [ssoIntegrationError, setSsoIntegrationError] = useState('');
  const [ssoCheckboxError, setSsoCheckboxError] = useState('');

  const [groupsData, setGroupsData] = useState(
    updateGroupsData || {
      name: '',
      currency: 'NZD',
      creator: 'Manually',
      website: '',
      status: 'Approved',
      country: 'NZ',
      billingCurrency: 'NZD',
      stripeCustomerId: '',
      stripeSubscriptionId: '',
      stripeProductId: '',
      stripePriceId: '',
      chainId: '',
      domain: '',
      serviceProvider: '1',
      notes: '',
      groupLogo: '',
    }
  );

  const [integrationOptions, setIntegrationOptions] = useState([]);

  const handleChangeSelect = (selectedOptions) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === selectedOptions.value
    );
    setSelectedCountry(selectedOptions);
    setGroupsData({
      ...groupsData,
      currency: currency[0].currencyCode,
      country: selectedOptions.value,
    });
  };

  const handleChangeSelectCurrency = (selectedOptions) => {
    setSelectedCurrency(selectedOptions);
    setGroupsData({
      ...groupsData,
      billingCurrency: selectedOptions.value,
    });
  };

  const fetchAzureIntegrations = async () => {
    if (!id) return;
    try {
      const groupId = id;

      const res = await AxiosAPI({
        method: 'post',
        url: `${API_Ingetration}?group_id=${groupId}`,
        data: { Channels: ['Azure'] },
      });

      const integrations = Array.isArray(res.data)
        ? res.data
        : res.data?.items || [];
      if (integrations && Array.isArray(integrations)) {
        const items = integrations.map((i) => ({
          label: i.name,
          value: String(i.id),
        }));
        setIntegrationOptions(items);

        if (ssoData.integrationId) {
          const exists = items.find(
            (opt) => opt.value === String(ssoData.integrationId)
          );
          if (!exists) {
            setSsoData((prev) => ({ ...prev, integrationId: '' }));
          }
        }
      }
    } catch (e) { }
  };

  const cleanArray = (arr) =>
    (arr || []).filter(
      (x) => x !== null && x !== undefined && String(x).trim() !== ''
    );

  const saveSsoSettings = async (body) => {
    try {
      const res = await AxiosAPI({
        method: 'post',
        url: postAPI_SSO_Settings,
        data: body,
      });

      if (res && res.data) {
        setSsoData((prev) => ({
          ...prev,
          provider: res.data.provider || prev.provider,
          clientId: res.data.clientId || prev.clientId,
          tenantId: res.data.tenantId || prev.tenantId,
          enforcedDomains: res.data.enforcedDomains || prev.enforcedDomains,
          bypassDomains: res.data.bypassDomains || prev.bypassDomains,
          status: res.data.status || prev.status,
          integrationId: res.data.integrationId || prev.integrationId,
        }));
      }

      return res;
    } catch (err) {
      console.error('saveSsoSettings error:', err.response?.data || err);
      NotificationManager.error(
        err.response?.data?.message || 'Failed to save SSO',
        '',
        5000
      );
      throw err;
    }
  };

  const fetchSsoByGroupId = async (groupId) => {
    if (!groupId) return;
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${getAPI_SSO_By_GroupId}?groupId=${groupId}`,
      });

      if (res && res.data) {
        // backend might return provider as number or string
        let providerValue = res.data.provider;
        if (typeof providerValue === 'number') {
          providerValue =
            providerNumberToString[providerValue] || String(providerValue);
        } else if (
          typeof providerValue === 'string' &&
          providerValue.trim() === ''
        ) {
          providerValue = '';
        }

        setIsSsoEnable(true);
        setSsoData({
          provider: providerValue || '',
          createdBy: res.data.createdBy || '',
          groupId: res.data.groupId || groupId,
          status: res.data.status || '',
          enforcedDomains: Array.isArray(res.data.enforcedDomains)
            ? res.data.enforcedDomains
            : [],
          bypassDomains: Array.isArray(res.data.bypassDomains)
            ? res.data.bypassDomains
            : [],
          integrationId: res.data.integrationId || '',
        });
      }
    } catch (err) {
      console.error('fetchSsoByGroupId error', err);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      setSsoData((prev) => ({
        ...prev,
        groupId: id,
      }));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Group_By_Id}/${id}`,
      })
        .then((res) => {
          if (res && res.data) {
            setGroupsData(res.data);
            if (res.data.groupLogo) {
              setLogoPreview(res.data.groupLogo);
            }

            const countryGroup = country.filter(
              (item) => item.code === res.data.country
            );
            if (countryGroup !== undefined && countryGroup.length > 0) {
              let countryObj = {
                value: countryGroup[0].code,
                label: countryGroup[0].name,
              };
              setSelectedCountry(countryObj);
            }
            const currencyGroup = billingCurrencyList.filter(
              (item) => item.currencyCode === res.data.billingCurrency
            );

            if (currencyGroup !== undefined && currencyGroup.length > 0) {
              let currency = {
                value: currencyGroup[0].currencyCode,
                label: currencyGroup[0].currencyCode,
              };
              setSelectedCurrency(currency);
            }
            fetchColorTheme(res.data.serviceProvider);

            if (res.data.ssoData) {
              let providerValue = res.data.ssoData.provider;
              if (typeof providerValue === 'number') {
                providerValue =
                  providerNumberToString[providerValue] ||
                  String(providerValue);
              }
              setIsSsoEnable(!!res.data.ssoData);
              setSsoData({
                provider: providerValue || '',
                createdBy: res.data.ssoData.createdBy || '',
                groupId: res.data.ssoData.groupId || id,
                status: res.data.ssoData.status || '',
                enforcedDomains: Array.isArray(res.data.ssoData.enforcedDomains)
                  ? res.data.ssoData.enforcedDomains
                  : [],
                bypassDomains: Array.isArray(res.data.ssoData.bypassDomains)
                  ? res.data.ssoData.bypassDomains
                  : [],
                integrationId: res.data.ssoData.integrationId || '',
              });
            }

            fetchSsoByGroupId(id);

            // fetch integrations
            fetchAzureIntegrations();
          }
        })
        .catch((err) => console.log('err', err));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchColorTheme = (serviceProvider) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Site_Settings}`,
    })
      .then((res) => {
        const matchedService = res.data.find(
          (item) => item.id.toString() === serviceProvider
        );
        if (matchedService) {
          const color = matchedService.colorTheme || 'light.purple';
          localStorage.setItem(themeColorStorageKey, color);
        } else {
          localStorage.setItem(themeColorStorageKey, 'light.purple');
        }
      })
      .catch((err) => console.error('Error fetching color theme:', err));
  };

  const [emailData, setEmailData] = useState({
    groupId: id,
    groupName: '',
    email: '',
    properties: ['-1'],
    roles: ['Admin'],
    creator: 'dashboard',
    firstName: '',
    lastName: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGroupsData({
      ...groupsData,
      [name]: value,
    });

    if (name === 'serviceProvider') {
      fetchColorTheme(value);
    }
  };

  const handleSsoChange = (e) => {
    const { name, value } = e.target;
    setSsoData({
      ...ssoData,
      [name]: value,
    });
  };

  const handleSsoArrayChange = (valueOrEvent, field) => {
    let value = [];

    if (valueOrEvent?.target?.value !== undefined) {
      value = valueOrEvent.target.value
        .split(',')
        .map((x) => x.trim())
        .filter((x) => x !== '');
    } else if (Array.isArray(valueOrEvent)) {
      value = valueOrEvent;
    }

    setSsoData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleInputChange = (e) => {
    setEmailData({
      ...emailData,
      [e.target.name]: e.target.value,
      groupName: groupsData.name,
    });
  };

  const buildSsoPayload = (ssoEnabled) => {
    let provider = ssoData.provider;

    if (typeof provider === 'number') {
      provider = providerNumberToString[provider] || String(provider);
    }

    const enforcedDomains = cleanArray(ssoData.enforcedDomains);
    const bypassDomains = cleanArray(ssoData.bypassDomains);
    const integrationId = ssoData.integrationId || null;

    const status = ssoEnabled ? 'Active' : 'Inactive';

    const payload = {
      provider,
      groupId: id,
      createdBy: 'Manually',
      enforcedDomains,
      bypassDomains,
      status,
      integrationId,
    };
    console.log(payload);
    return payload;
  };

  const handleSubmit = async () => {
    setSaving(true);

    try {
      // Myma SSO validations
      if (
        (groupsData.serviceProvider === '4' ||
          groupsData.serviceProvider === '1' ||
          groupsData.serviceProvider === '7') &&
        isSsoEnable
      ) {
        if (!ssoData.provider) {
          setSsoProviderError('Please select a provider before saving');
          setSaving(false);
          return;
        }

        if (
          ssoData.provider === 'AzureApp' &&
          integrationOptions.length > 0 &&
          !ssoData.integrationId
        ) {
          setSsoIntegrationError('Please select an integration before saving');
          setSaving(false);
          return;
        }
      }

      if (
        (groupsData.serviceProvider === '2' ||
          groupsData.serviceProvider === '5') &&
        isSsoEnable
      ) {
        ssoData.provider = 'Synxis';
      }

      // Save group first
      const groupResult = await submit(groupsData);

      if (
        id &&
        (groupsData.serviceProvider === '4' ||
          groupsData.serviceProvider === '7' ||
          groupsData.serviceProvider === '1' ||
          groupsData.serviceProvider === '2' ||
          groupsData.serviceProvider === '5')
      ) {
        const payload = buildSsoPayload(isSsoEnable); // Active or Inactive
        await saveSsoSettings(payload); // now always called
      }
      NotificationManager.success('Group saved successfully', '', 3000);
      toggle && toggle();
    } catch (err) {
      console.error('handleSubmit error', err.response?.data || err);
      NotificationManager.error(
        'Failed to save group or SSO settings',
        '',
        3000
      );
    } finally {
      setSaving(false);
    }
  };

  const handleInvitation = () => {
    const auditData = {
      content: emailData,
      createdBy: 'Group Form',
    };
    var body = { ...emailData, auditData: auditData };
    AxiosUserAPI({
      method: 'post',
      url: `${postAPI_Invite_User}`,
      data: body,
    }).then(
      (res) => {
        if (res.data.HttpStatusCode === 400 && res.data.Messages?.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          NotificationManager.success(
            '',
            'Invitation sent successfully',
            3000,
            null,
            null,
            'success'
          );
          setEmailData({
            ...emailData,
            email: '',
          });

          setInviteData(res.data.url);
        }
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  };

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const toggleGallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
    setLogoPreview(image.src);
    setGroupsData((prev) => ({ ...prev, groupLogo: image.src }));
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={6} className="mb-6">
                  <Label>Name</Label>
                  <Input className='input_sty'
                    type="text"
                    value={groupsData.name}
                    onChange={handleChange}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Currency</Label>
                  <Input className='input_sty'
                    required
                    name="currency"
                    type="text"
                    disabled="disabled"
                    onChange={handleChange}
                    value={groupsData.currency}
                  ></Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Billing Currency</Label>
                  <Input className='input_sty'
                    type="select"
                    value={groupsData.billingCurrency}
                    name="billingCurrency"
                    onChange={handleChange}
                  >
                    <option value="NZD">NZD</option>
                    <option value="AUD">AUD</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-6">
                  <Label>Website</Label>
                  <Input className='input_sty'
                    type="text"
                    value={groupsData.website}
                    onChange={handleChange}
                    name="website"
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Country</Label>
                  <Select
                    isMulti={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="country"
                    value={selectedCountry}
                    placeholder="Select Country"
                    onChange={handleChangeSelect}
                    options={reactSelectOptionDiffrentPro(
                      country,
                      true,
                      'code',
                      'name',
                      ''
                    )}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Status</Label>
                  <Input className='input_sty'
                    type="select"
                    value={groupsData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="PendingApproval">
                      Pending For Approval
                    </option>
                    <option value="Approved">Approved</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Domain</Label>
                  <Input className='input_sty'
                    type="select"
                    value={groupsData.domain}
                    name="domain"
                    onChange={handleChange}
                  >
                    <option value="0">Select Domain</option>
                    <option value="AccommodationProvidersGroup">
                      Accommodation Providers Group
                    </option>
                    <option value="HolidayHomesGroup">
                      Holiday Homes Group
                    </option>
                  </Input>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Service Provider</Label>
                  <Input className='input_sty'
                    type="select"
                    value={groupsData.serviceProvider}
                    name="serviceProvider"
                    onChange={handleChange}
                  >
                    {serviceProviders &&
                      serviceProviders.map((elem) => (
                        <option key={elem.id} value={elem.id}>
                          {elem.fromName}
                        </option>
                      ))}
                  </Input>
                </Colxx>
                {(groupsData.serviceProvider === '5' || groupsData.serviceProvider === '2') && (
                  <Colxx sm={3} className="mb-3">
                    <Label> Chain ID</Label>
                    <Input className='input_sty'
                      type="text"
                      name="chainId"
                      value={groupsData.chainId}
                      onChange={handleChange}
                    />
                  </Colxx>
                )}
                {id &&
                  (groupsData.serviceProvider === '4' ||
                    groupsData.serviceProvider === '7' ||
                    groupsData.serviceProvider === '1' ||
                    groupsData.serviceProvider === '2' ||
                    groupsData.serviceProvider === '5') && (
                    <Colxx sm={3} className="mb-3">
                      <div style={{ marginTop: '30px', marginLeft: '20px' }}>
                        <Label check>
                          <Input className='input_sty'
                            type="checkbox"
                            checked={isSsoEnable}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              if (
                                groupsData.serviceProvider === '2' ||
                                groupsData.serviceProvider === '5'
                              ) {
                                setIsSsoEnable(checked);
                                setSsoCheckboxError('');
                                return;
                              }

                              if (
                                groupsData.serviceProvider === '4' ||
                                groupsData.serviceProvider === '7' ||
                                groupsData.serviceProvider === '1'
                              ) {
                                const hasIntegration =
                                  integrationOptions.length > 0;

                                if (checked && !hasIntegration) {
                                  setIsSsoEnable(false);
                                  setSsoCheckboxError(
                                    'Create integration first'
                                  );
                                  return;
                                }

                                setIsSsoEnable(checked);
                                setSsoCheckboxError('');
                              }
                            }}
                          />{' '}
                          Enable SSO
                        </Label>

                        {ssoCheckboxError && (
                          <div
                            style={{
                              color: 'red',
                              fontSize: '12px',
                              marginTop: '5px',
                            }}
                          >
                            {ssoCheckboxError}
                          </div>
                        )}
                      </div>
                    </Colxx>
                  )}

                {id &&
                  (groupsData.serviceProvider === '4' ||
                    groupsData.serviceProvider === '1' ||
                    groupsData.serviceProvider === '7') &&
                  isSsoEnable && (
                    <>
                      <Colxx sm={12} className="mb-3">
                        <h5 style={{ marginTop: '20px', marginBottom: '15px' }}>
                          SSO Configuration
                        </h5>
                      </Colxx>

                      <Colxx sm={6} className="mb-3">
                        <Label>Provider</Label>
                        <Input className='input_sty'
                          type="select"
                          name="provider"
                          value={ssoData.provider || ''}
                          onChange={(e) => {
                            const val = e.target.value;

                            if (
                              val === 'AzureApp' &&
                              integrationOptions.length === 0
                            ) {
                              setIsSsoEnable(false);
                              setSsoData({ provider: '', integrationId: '' });
                              setSsoProviderError('Create integration first');
                              return;
                            }

                            setSsoData({
                              ...ssoData,
                              provider: val,
                              integrationId: '',
                            });

                            setSsoProviderError('');
                          }}
                        >
                          <option value="">Select Provider</option>
                          {knownProviders.map((p) => (
                            <option key={p} value={p}>
                              {p === 'AzureApp' ? 'Azure' : p}
                            </option>
                          ))}
                        </Input>

                        {ssoProviderError && (
                          <div
                            style={{
                              color: 'red',
                              fontSize: '12px',
                              marginTop: '5px',
                            }}
                          >
                            {ssoProviderError}
                          </div>
                        )}
                      </Colxx>
                      {ssoData.provider === 'AzureApp' ? (
                        integrationOptions.length > 0 ? (
                          <Colxx sm={6} className="mb-3">
                            <Label>Integration</Label>
                            <Input className='input_sty'
                              type="select"
                              name="integrationId"
                              value={ssoData.integrationId || ''}
                              onChange={(e) => {
                                setSsoData((prev) => ({
                                  ...prev,
                                  integrationId: e.target.value,
                                }));
                                if (e.target.value) setSsoIntegrationError('');
                              }}
                            >
                              <option value="">Select Integration</option>
                              {integrationOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </Input>

                            {ssoIntegrationError && (
                              <div
                                style={{
                                  color: 'red',
                                  fontSize: '12px',
                                  marginTop: '5px',
                                }}
                              >
                                {ssoIntegrationError}
                              </div>
                            )}
                          </Colxx>
                        ) : (
                          <Colxx sm={6} className="mb-3"></Colxx>
                        )
                      ) : (
                        <Colxx sm={6} className="mb-3"></Colxx>
                      )}

                      <Colxx sm={6} className="mb-3">
                        <Label>Enforced Domains</Label>
                        <TagsInput
                          value={ssoData.enforcedDomains || []}
                          onChange={(value) =>
                            handleSsoArrayChange(value, 'enforcedDomains')
                          }
                          inputProps={{
                            placeholder: 'Add domain e.g gmail.com',
                          }}
                        />
                      </Colxx>

                      <Colxx sm={6} className="mb-3">
                        <Label>Bypass Domains</Label>
                        <TagsInput
                          value={ssoData.bypassDomains || []}
                          onChange={(value) =>
                            handleSsoArrayChange(value, 'bypassDomains')
                          }
                          inputProps={{
                            placeholder: 'Add domain e.g hotmail.com',
                          }}
                        />
                      </Colxx>


                    </>
                  )}

                <Colxx sm={6} className="mb-3">
                  <Label>Notes</Label>
                  <Input className='input_sty'
                    type="textarea"
                    value={groupsData.notes}
                    name="notes"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
              </Row>
              {(groupsData.serviceProvider === '5' || groupsData.serviceProvider === '2') && (
                <Colxx sm={6} className="mb-3">
                  <Label><b>Group Logo</b></Label>
                  <Row>
                    <Colxx sm={4} className="mb-2">
                      <img
                        style={{ width: '100%', height: '90%', objectFit: 'contain' }}
                        alt="Group logo"
                        src={logoPreview || 'https://via.placeholder.com/150/'}
                      />
                    </Colxx>
                    <Colxx sm={2}>
                      <Label>Browse</Label>
                      <div
                        className="iconsminds-photo"
                        onClick={toggleGallery}
                        style={{
                          cursor: 'pointer',
                          fontSize: '28px',
                          color: '#73236b',
                        }}
                      />
                    </Colxx>

                  </Row>

                  {/* Gallery Modal */}
                  <Modal
                    isOpen={galleryVisible}
                    toggle={toggleGallery}
                    style={{ maxWidth: '1000px' }}
                  >
                    <ModalHeader toggle={toggleGallery}>
                      Select Image or Upload New Image
                    </ModalHeader>
                    <ModalBody>
                      <ImageGallery
                        selectedImage={selectedImage}
                        togglegallery={toggleGallery}
                        hideUserUploads={false}
                        searchText={''}
                      />
                    </ModalBody>
                  </Modal>
                </Colxx>
              )}
            </Colxx>
          </Row>
          {groupsData.name !== '' && (
            <div>
              <h4>Send Account Creation Invitation</h4>
              <Row>
                <Colxx sm={5} className="mb-3">
                  <Label>Email</Label>
                  <Input className='input_sty'
                    type="text"
                    name="email"
                    value={emailData.email}
                    min={1}
                    onChange={(event) => handleInputChange(event)}
                  />
                </Colxx>
              </Row>
              {inviteData !== '' ? (
                <Row>
                  <Colxx sm={12} className="mb-3">
                    <div className="code-snippet">
                      <span style={{ wordWrap: 'break-word' }}>
                        {inviteData}
                      </span>
                    </div>
                    <CopyToClipboard
                      text={inviteData}
                      onCopy={() => setCopied(true)}
                    >
                      <Button
                        color="success"
                        size="xs"
                        style={{ marginTop: '10px' }}
                      >
                        Copy the code snippet
                      </Button>
                    </CopyToClipboard>
                    {copied ? <div>Copied.</div> : null}
                  </Colxx>
                </Row>
              ) : (
                ''
              )}

              <h4>Stripe Integration</h4>
              <Row>
                <Colxx sm={4} className="mb-3">
                  <Label>Customer ID</Label>
                  <Input className='input_sty'
                    type="text"
                    name="stripeCustomerId"
                    value={groupsData.stripeCustomerId}
                    onChange={(event) => handleChange(event)}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Product ID</Label>
                  <Input className='input_sty'
                    type="text"
                    name="stripeProductId"
                    value={groupsData.stripeProductId}
                    onChange={(event) => handleChange(event)}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Price ID</Label>
                  <Input className='input_sty'
                    type="text"
                    name="stripePriceId"
                    value={groupsData.stripePriceId}
                    onChange={(event) => handleChange(event)}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Subscription ID</Label>
                  <Input className='input_sty'
                    type="text"
                    name="stripeSubscriptionId"
                    value={groupsData.stripeSubscriptionId}
                    onChange={(event) => handleChange(event)}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Promo Code</Label>
                  <Input className='input_sty'
                    type="text"
                    name="stripePromoCode"
                    value={groupsData.stripePromoCode}
                    disabled
                  />
                </Colxx>
              </Row>

              <Button color="secondary" outline onClick={handleInvitation}>
                Send Invite
              </Button>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit} disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
          <Button color="secondary" onClick={toggle} disabled={saving}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
